module.exports = __webpack_public_path__ + "static/media/product-7.fab6910a.jpg";